<template>
  <div class="wrapper">
    <el-dialog
      :title="$t('tipsType.ywhz')"
      :visible="dialogAdressVisible"
      class="adress"
      @close="hideDialog"
    >
      <div class="adress-form">
        <div class="form-section form-name">
          <input
            type="text"
            :placeholder="$t('enter', {text: $t('cooperationType')})"
            class="input-text input-control"
            v-model="modifyData.name"
            disabled
            style="width: 566px"
          >
          <label for class="input-label">{{$t('cooperationType')}}</label>
        </div>

        <div class="form-section form-adress">
          <textarea
            class="input-textarea input-control"
            cols="25"
            rows="3"
            :placeholder="$t('enter', {text: $t('cooperationIntention')})"
            v-model="form.intention"
          ></textarea>
          <label for class="input-label">{{$t('cooperationIntention')}}</label>
        </div>

        

         <div class="form-section">
          <input
            type="text"
            :placeholder="$t('enter', {text: $t('corporateName')})"
            minlength="7"
            maxlength="11"
            class="input-text input-control"
            v-model="form.name"
          >
          <label for class="input-label">{{$t('corporateName')}}</label>
        </div>


        <div class="form-section">
          <input
            type="text"
            :placeholder="$t('enter', {text: $t('linkman')})"
            minlength="7"
            maxlength="11"
            class="input-text input-control"
            v-model="form.user"
          >
          <label for class="input-label">{{$t('linkman')}}</label>
        </div>


        
        <div class="form-section form-adress form-location">
          <el-cascader :placeholder="$t('pleaseSelect')" size="medium" :options="options" separator=" " v-model="selectedOptions"></el-cascader>
        </div>



        <div class="form-section">
          <input
            type="text"
            :placeholder="$t('enter', {text: $t('mobile')})"
            minlength="7"
            maxlength="11"
            class="input-text input-control"
            v-model="form.mobile"
          >
          <label for class="input-label">{{$t('mobile')}}</label>
        </div>


        <div class="form-section">
          <input
            type="text"
            :placeholder="$t('enter', {text: $t('email')})"
            class="input-text input-control"
            v-model="form.email"
          >
          <label for class="input-label">{{$t('email')}}</label>
        </div>
        <div class="tips">{{$t('messageTips')}}</div>
      </div>
      <div class="form-foot">
        <div class="foot-btn save" @click="saveFormInfo">{{$t('save')}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { CodeToText } from "element-china-area-data";
import * as locationData from "@/utils/location.js";
import { inputCheckPhone } from "@/utils/index";
import { mapActions } from "vuex";
export default {
  name: "SelectAddress",
  components: {},
  props: {
    dialogAdressVisible: {
      type: Boolean,
      default: false
    },
    modifyData: Object
  },
  data() {
    return {
      form: {
        type: '',
        intention: "", // 意向
        name: '', // 单位名称
        user: '',// 联系人
        area: '', // 省市县
        mobile: "", // 手机号
        email: "" // 邮箱
      },
      //地址管理
      // addressArray:[],
      userName: null,
      telPhone: null,
      selectedOptions: [],
      detailAddress: null,
      postCode: null,
      addressTag: null,
      options: {}, //省市联动数据
      type: 0, // 0为新增 ,1为修改
      provinceKey: 110000, //省份id
      cityKey: 110100, //市id
      areaKey: 110101//区域idmultiIndex: [110000, 110100, 110101],
    };
  },
  computed: {
    selectedOptionsText() {
      let arr = this.selectedOptions;
      return (
        CodeToText[arr[0]] + " " + CodeToText[arr[1]] + " " + CodeToText[arr[2]]
      );
    },
    pickerIndexArr() {
      return [this.provinceKey, this.cityKey, this.areaKey];
    }
  },
  methods: {

    init(areaId) {
      this.getFullOptions(areaId, locationData);
    },
    getFullOptions(id, data) {
      for (var i = 0; i < data.length; i++) {
        if (id == data[i].value) {
          if (!data[i].children) {
            this.areaKey = data[i].value - 0;
            return true;
          } else if (data[i].hasOwnProperty("children")) {
            if (data[i].children[0] && !data[i].children[0].children) {
              this.cityKey = data[i].value;
              return true;
            } else {
              this.provinceKey = data[i].value;
              return true;
            }
          }
        } else {
          if (data[i].hasOwnProperty("children")) {
            if (data[i].children[0] !== undefined) {
              if (data[i].children[0].hasOwnProperty("children")) {
                this.provinceKey = data[i].value;
              } else {
                this.cityKey = data[i].value;
              }
            }
            if (typeof data[i].children != "undefined") {
              var res = this.getFullOptions(id, data[i].children);
              if (res) {
                return true;
              }
            }
          }
        }
      }
    },
    hideDialog() {
      this.$emit("hideDialog");
    },
    saveFormInfo() {
      let form = {
        id: 1,
        data: {
          1: this.modifyData.name,
          2: this.form.intention,
          3: this.form.name,
          4: this.form.user,
          5: this.selectedOptionsText,
          6: this.form.mobile,
          7: this.form.email
        }
      }
     this.$api.formAddsubmit(form).then(res => {
       if(res.status) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.hideDialog()
        this.form = {
          type: '',
          intention: "", // 意向
          name: '', // 单位名称
          user: '',// 联系人
          area: '', // 省市县
          mobile: "", // 手机号
          email: "" // 邮箱
        }
       } else {
        this.$message({
          message: res.msg,
          type: 'warning'
        });
       }
     })
    },
    ...mapActions(["getUserShipListAction"]),
    formReset() {
      this.userName = null;
      this.telPhone = null;
      this.selectedOptions = [];
      this.detailAddress = null;
      this.postCode = null;
      this.addressTag = null;
    }
  },
  created() {
    let addressList = this.$storage.get('areaList')
    if (addressList.hasOwnProperty('data')) {
      this.options = addressList.data;
    } else {
      this.options = addressList;
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
@import "@/assets/css/variable.scss";
.adress-form {
  width: 600px;
  margin: 0 auto;
  padding: 30px 10px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  align-content: flex-start;
  .form-section {
    position: relative;
    margin-bottom: 15px;
    &.form-adress {
      width: 100%;
    }
    .input-control {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      outline: none;
      padding: 10px 16px;
      border: 1px solid #e0e0e0;
      transition: border-color 0.25s linear;
      &.input-text {
        height: 18px;
        line-height: 18px;
      }
      &:focus {
        border-color: $theme-color;
      }
      &:placeholder-shown::placeholder {
        color: transparent;
      }
      &:not(:placeholder-shown)::placeholder,
      &:focus::placeholder {
        color: #b0b0b0;
      }
      /* 线框样式label定位 */
      &:not(:placeholder-shown) ~ .input-label,
      &:focus ~ .input-label {
        color: $theme-color;
        transform: scale(0.75) translate(-2px, -24px);
      }
    }
    .input-text {
      width: 260px;
    }
    .input-textarea {
      width: 100%;
      box-sizing: border-box;
      resize: none;
    }
    .input-label {
      position: absolute;
      font-size: 16px;
      line-height: 1.5;
      left: 16px;
      top: 8px;
      color: #b0b0b0;
      background: #fff;
      padding: 0 2px;
      transform-origin: 0 0;
      pointer-events: none;
      transition: all 0.25s linear;
      display: none\0;
    }
  }
  .invoice-section {
    position: relative;
    padding-left: 100px;
    width: 100%;
    .tit {
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      line-height: 40px;
      text-align: right;
    }
    .invoice-tabs {
      width: 100%;
      display: flex;
      height: 40px;
      line-height: 40px;
      align-items: center;
      .invoice-type {
        flex: 1;
        border: 1px solid $border;
        text-align: center;
        cursor: pointer;
        &.active {
          border-color: $theme-color;
          color: $theme-color;
        }
        &.self {
          margin-right: 30px;
        }
      }
    }
    .invoice-input-wrap {
      input {
        width: 100%;
        height: 40px;
        padding: 10px 16px;
        border: 1px solid $border;
        font-size: 14px;
        line-height: 18px;
        background: #fff;
        box-sizing: border-box;
        transition: border-color 0.2s linear;
        &:focus {
          border-color: $theme-color;
        }
      }
      span {
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
.form-foot {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  background: #f5f5f5;
  .foot-btn {
    width: 160px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    &.save {
      background: $theme-color;
      margin-right: 20px;
    }
    &.cancel {
      background: #b0b0b0;
      transition: all 0.2s;
      &:hover {
        background: #757575;
      }
    }
  }
}
.tips {
    text-align: center;
    width: 100%;
    color: rgb(255, 0, 0);
}
</style>